import { PRIMARY_INDUSTRIES } from '@/constants/industries';

export const findPrimaryIndustryBySlug = (
  primaryIndustrySlug: string | undefined | null
) => {
  if (!primaryIndustrySlug)
    return {
      primaryIndustryId: null,
      primaryIndustryLabel: null,
    };

  const industryEntry = Object.entries(PRIMARY_INDUSTRIES).find(
    ([_industryId, industry]) => industry.slug === primaryIndustrySlug
  );
  if (!industryEntry)
    return {
      primaryIndustryId: null,
      primaryIndustryLabel: null,
    };

  return {
    primaryIndustryId: industryEntry[0],
    primaryIndustryLabel: industryEntry[1].label,
  };
};
